import { render, staticRenderFns } from "./CalcCard.vue?vue&type=template&id=673ec96a"
import script from "./CalcCard.vue?vue&type=script&lang=js"
export * from "./CalcCard.vue?vue&type=script&lang=js"
import style0 from "./CalcCard.vue?vue&type=style&index=0&id=673ec96a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports